<template>
  <NuxtLayout>
    <div :class="$style.root">
      <code :class="$style.code" v-if="isDev">{{ error }}</code>
      <div :class="$style.error" v-else>
        <div :class="$style.message">Something went wrong.</div>
      </div>
    </div>
  </NuxtLayout>
</template>

<script setup lang="ts">
const router = useRouter()
const runtimeConfig = useRuntimeConfig()
const localePath = useLocalePath()

const props = defineProps({
  error: Object
})

const handleError = () => {
  clearError()
  router.push(localePath({ name: 'index' }))
}

const isDev = runtimeConfig?.public?.env === 'development'

const error = computed(() => props.error)
watch(error, (error) => {
  if (error) {
  }
})
</script>

<style module>
.root {
  flex: 1;

  display: flex;
  flex-direction: column;
  justify-content: center;

  height: 100%;
}


.code {
  font-size: 18px;
  line-height: 1;
  padding: 2em;
  background-color: #e2e2e2;
}

.error {
  composes: container--default font-size-large from global;

  margin-top: calc(var(--unit--vertical) * 3);

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: var(--unit--vertical);
}

.message {}

.button {
  composes: reset-button from global;
  text-transform: lowercase;
  text-decoration-line: underline;
}
</style>
